import { useQuery } from '@tanstack/react-query';

import { getCategories } from '@website/services/categories.service';

export function useCategories(locale: string) {
  return useQuery({
    queryKey: ['categories', locale],
    queryFn: () => getCategories(locale),
    staleTime: 5 * 60 * 1000, // 5 minutes - categories don't change often
    retry: (failureCount) => failureCount < 3
  });
}
